import { render, staticRenderFns } from "./tree-node-wrapper.vue?vue&type=template&id=f0598e96&"
import script from "./tree-node-wrapper.vue?vue&type=script&lang=js&"
export * from "./tree-node-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports